import axios, { AxiosError } from "axios";

// GetContext((context) => {
//     axios.defaults.headers.common["X-sca-ide-org-context"] = context.currentOrganization.id;
//     axios.defaults.headers.common["X-sca-ide-org-membership"] = context.currentMembership.type;
// });

axios.defaults.withCredentials = true;

axios.interceptors.response.use(
    function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },
    function (error: AxiosError) {
        if (error.response?.status == 401) {
            window.location.assign("/Account/SignIn");
        }
        return Promise.reject(error);
    }
);

export let TrimFields = (obj) => {
    Object.keys(obj).map((k) => (obj[k] = obj[k].trim()));
    return obj;
};

export default axios;

export interface AutoWrappedResponse<T> {
    result: T;
}